import { DataFieldTemplate } from "../../templates/DataFieldTemplate";

export abstract class DataFieldValue {
	public static readonly $type: string = "DataFieldValue";
	public readonly $type: string = DataFieldValue.$type;

	public id?: number;
	public template!: DataFieldTemplate;
}
